import { render, staticRenderFns } from "./MiniWizardExpandableImplicitEditModeContent.vue?vue&type=template&id=36028c3e"
import script from "./MiniWizardExpandableImplicitEditModeContent.vue?vue&type=script&lang=js"
export * from "./MiniWizardExpandableImplicitEditModeContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports